import { render, staticRenderFns } from "./AlarmCategory.vue?vue&type=template&id=46e0a9c8&scoped=true"
import script from "./AlarmCategory.vue?vue&type=script&lang=js"
export * from "./AlarmCategory.vue?vue&type=script&lang=js"
import style0 from "./AlarmCategory.vue?vue&type=style&index=0&id=46e0a9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e0a9c8",
  null
  
)

export default component.exports